import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const delivery = css`
  display: flex;
  flex-direction: column;
  gap: calc(var(${spacing.xxs}) / 2);
  margin: 0;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  color: var(${colors.content.default});
`;

/* Both labels stay on one line, so the block is always two lines tall and its
   height stays the same across a row of cards. "Est to arrive by Christmas" is
   long enough to wrap on a narrow card, which would otherwise push that card's
   delivery row out of line with its neighbours. */
const oneLine = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const label = css`
  ${oneLine}
  color: var(${colors.content.default});
`;

/* A special event is a cut-off the customer is shopping against, so its label
   is promoted out of the secondary colour. */
export const eventLabel = css`
  ${oneLine}
  color: var(${colors.content.positive});
`;

export const date = css`
  font-weight: 700;
`;

export const free = css`
  color: var(${colors.content.positive});
`;
